import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';
import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.VIDEOS.LIST');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (options) {

  options = {
    ...options,
    paging: { size: 1000 },
  };

  return function (dispatch) {
    dispatch(START());

    const promise = vodAdapter.items.list(options);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeArrayOfVideos(response.data),
          };

          dispatch(SUCCESS({}, response));
          return response;
        },

        function (response) {
          dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'dashboard.videos.list' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/videos/list.js